module.exports = __webpack_public_path__ + "img/icon-ve_choxacnhan.56034704.svg";